// import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'mapbox-gl/dist/mapbox-gl.css';
// import { Col, Row, Container } from 'react-bootstrap';
import { PortDashboard } from './portDashboard'
import { LandingPage} from './landingPage'


import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";


function App() {
  return (
    <BrowserRouter>
    {/* <Container fluid={true}> */}
      {/* <Row className="body">
        <Col md= {10}>
          <img src="/marin.png" alt="image" height = "40px"/>
        </Col>

        <Col>
            <Link to='/'>Home</Link>
        </Col>
        <Col>
            <Link to='/dashboard'>Dashboard</Link>
        </Col>
      </Row> */}

          <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/dashboard" element={<PortDashboard />} />
          </Routes>

    {/* </Container> */}
    </BrowserRouter>
  );
}

export default App;
